module.exports = __webpack_public_path__ + "img/3.5f7a7403.png";